<script>
import {store} from '../../store';

export default {
    name: 'MenuDropDownMe',
    props: {
        me: null,
        block: false
    },
    computed: {
        usuario: function(){
            return window.localStorage.getItem('usuario')
        }
    },
    methods: {
        logout(){
            store.commit('logout');
            this.$router.push('/login');
        }
    },
};
</script>

<template>
    <li class="dropdown nav-item">
        <a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown">
            <i class="fa fa-user-circle-o"></i> 
            <span class="username">{{ usuario }}</span> 
            <span class="caret"></span>
        </a>
        <ul class="dropdown-menu user-dropdown">
            <!--<li><a href="#" class="menu-item">
                <i class="fa fa-user text-primary"></i> 
                <span>Meus Dados</span>
                <small class="text-muted">Informações pessoais</small>
            </a></li>-->
            
            <li v-if="me.admin && ! block">
                <a href="#/config" class="menu-item">
                    <i class="fa fa-cogs text-primary"></i> 
                    <span>Configuração</span>
                    <small class="text-muted">Configurações do sistema</small>
                </a>
            </li>
            
            <li v-if="!block">
                <a href="#/update-password" class="menu-item">
                    <i class="fa fa-key text-warning"></i> 
                    <span>Alterar Senha</span>
                    <small class="text-muted">Segurança da conta</small>
                </a>
            </li>
            
            
            <li v-if="me.admin && ! block">
                <a href="#/eventos" class="menu-item">
                    <i class="fa fa-exclamation-triangle text-orange"></i> 
                    <span>Eventos Default</span>
                    <small class="text-muted">Configurar eventos padrão</small>
                </a>
            </li>
            
            
            <li>
                <a @click="logout()" class="menu-item logout-item" style="cursor:pointer;">
                    <i class="fa fa-sign-out text-danger"></i> 
                    <span>Sair</span>
                    <small class="text-muted">Encerrar sessão</small>
                </a>
            </li>
        </ul>
    </li>
</template>

<style scoped>
.user-menu-toggle {
    font-size: 13px;
    font-weight: 600;
    color: #2c3e50 !important;
    text-decoration: none;
    transition: all 0.3s ease;
    padding: 15px 20px;
    text-transform: uppercase;
}

.user-menu-toggle:hover {
    color: #8e44ad !important;
    background-color: rgba(142, 68, 173, 0.1);
}

.user-menu-toggle i {
    margin-right: 8px;
    font-size: 16px;
}

.username {
    margin: 0 5px;
}

.user-dropdown {
    min-width: 280px;
    border-radius: 8px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    border: none;
    padding: 10px 0;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    right: 0;
    left: auto;
}

.menu-item {
    padding: 12px 20px !important;
    color: #2c3e50 !important;
    text-decoration: none !important;
    display: flex !important;
    align-items: center;
    transition: all 0.3s ease;
    border-left: 3px solid transparent;
    text-transform: uppercase;
    font-size: 12px;
}

.menu-item:hover,
.menu-item:focus {
    background: linear-gradient(90deg, rgba(142, 68, 173, 0.1) 0%, rgba(142, 68, 173, 0.05) 100%);
    color: #2c3e50 !important;
    text-decoration: none !important;
    border-left: 3px solid #8e44ad;
    transform: translateX(2px);
}

.menu-item i {
    font-size: 16px;
    width: 20px;
    margin-right: 12px;
    text-align: center;
}

.menu-item span {
    font-weight: 600;
    flex: 1;
}

.menu-item small {
    display: block;
    font-size: 10px;
    margin-top: 2px;
    margin-left: 32px;
    font-weight: normal;
    text-transform: none;
}

.menu-divider {
    height: 1px;
    background: linear-gradient(90deg, transparent 0%, #e9ecef 50%, transparent 100%);
    margin: 8px 20px;
}

.text-orange {
    color: #f39c12 !important;
}

/* Efeito especial para logout */
.logout-item:hover {
    background: linear-gradient(90deg, rgba(231, 76, 60, 0.1) 0%, rgba(231, 76, 60, 0.05) 100%) !important;
    border-left: 3px solid #e74c3c !important;
}

.logout-item:hover i {
    animation: signOutPulse 0.5s ease-in-out;
}

/* Animação para o dropdown */
.user-dropdown {
    opacity: 0;
    transform: translateY(-10px);
    transition: all 0.3s ease;
}

.dropdown.open .user-dropdown {
    opacity: 1;
    transform: translateY(0);
}

/* Responsividade */
@media (max-width: 767px) {
    .user-dropdown {
        min-width: 250px;
        margin-top: 5px;
    }
    
    .menu-item {
        padding: 10px 15px !important;
    }
    
    .menu-item small {
        margin-left: 27px;
    }
    
    .username {
        display: none;
    }
    
    .user-menu-toggle {
        padding: 15px 10px;
    }
}

/* Efeito hover adicional para ícones */
.menu-item:hover i {
    transform: scale(1.1);
    transition: transform 0.2s ease;
}

/* Animação especial para o ícone de sair */
@keyframes signOutPulse {
    0%, 100% { transform: scale(1.1); }
    50% { transform: scale(1.2); }
}

/* Indicador visual para admin */
.user-menu-toggle::after {
    content: '';
    position: absolute;
    top: 8px;
    right: 8px;
    width: 8px;
    height: 8px;
    background: #8e44ad;
    border-radius: 50%;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.dropdown.admin .user-menu-toggle::after {
    opacity: 1;
}
</style>
